import { useFeatureFlag } from '../components/featureFlags/FeatureFlagProvider';
import { FeatureFlag } from '../utils/featureFlags';
import type { UserTenantResponseAPI } from '../types/user';

export const useIsSingleTenant = (tenant: UserTenantResponseAPI) => {
    const { getFlag } = useFeatureFlag();
    const isOrgAccEnabled = getFlag(FeatureFlag.ORGACC);

    return !!(
        isOrgAccEnabled &&
        tenant.organization?.accountId &&
        tenant.organization?.tenantCount === 1
    );
};
